import { Component, Input } from '@angular/core';
import { FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ProfessionService } from '../../services/profession.service';
import { IProfession } from '../../interfaces/profession/iprofession';


@Component({
  selector: 'split-representative-form',
  templateUrl: './split-representative-form.component.html',
  styleUrls: ['./split-representative-form.component.scss']
})
export class SplitRepresentativeFormComponent {
  protected listProfission: IProfession[] = [];

  protected validators = Validators;

  protected form!: FormGroup;

  @Input() public formGroupName!: string;

  constructor(
    private formGroupDirective: FormGroupDirective
  ) {}

  ngOnInit(): void {
    this.form = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
  }
}